import React, { ReactElement } from 'react';

import { PublicRoute } from '@stur/containers/public-route';
import { TermsConditionsPage } from '@stur/containers/terms-conditions';

export default (): ReactElement => <PublicRoute component={TermsConditionsPage} />;
